import { Company } from './company';

export interface GuideStats {
  guide_id: string;
  downloads: number;
  started: number;
  prepared: number;
  shared: number;
  favourites: number;
}

export interface GuideDose {
  coffee: number;
  water: number;
  cups: number;
}

export enum GrindSize {
  Coarse = 'Coarse',
  Medium = 'Medium',
  Fine = 'Fine',
  ExtraFine = 'Extra Fine',
  Turkish = 'Turkish',
}

export enum BrewMethod {
  AeroPress = 'AeroPress',
  Chemex = 'Chemex',
  HarioV60 = 'Hario V60',
  Bonmac = 'Bonmac',
  Beehouse = 'Beehouse',
  KalitaWave = 'Kalita Wave',
  MokaPot = 'Moka Pot',
  FrenchPress = 'French Press',
  Siphon = 'Siphon',
}

export enum StepType {
  boil = 'boil',
  grind = 'grind',
  bloom = 'bloom',
  pour = 'pour',
  wait = 'wait',
  stir = 'stir',
  prepare = 'prepare',
}

export interface GuideStep {
  id: string;
  name: string;
  description_text?: string;
  image_identifier?: string;
  type: StepType;
  amount: number;
  amount_unit: string;
  time_at: number;
  time_duration: number;
}

export interface GuideOwner {
  name: string;
  id: string;
  image_url: string;
}

export interface Guide {
  id: string;
  name: string;
  public_url: string;
  description_text?: string;
  image_identifier?: string;
  method: BrewMethod;
  grind_size: GrindSize;
  steps: GuideStep[];
  user_id: string;
  user: GuideOwner;
  shared: boolean;
  temperature: number;
  temperature_unit: string;
  company_id?: string;
  company?: Company;
}

export const methods = [
  BrewMethod.Chemex,
  BrewMethod.HarioV60,
  BrewMethod.AeroPress,
  BrewMethod.Beehouse,
  BrewMethod.Bonmac,
  BrewMethod.KalitaWave,
  BrewMethod.MokaPot,
  BrewMethod.FrenchPress,
  BrewMethod.Siphon,
].map(item => ({ value: item, label: item }));

export const grindSizes = [
  GrindSize.Coarse,
  GrindSize.Medium,
  GrindSize.Fine,
  GrindSize.ExtraFine,
  GrindSize.Turkish,
].map(item => ({ value: item, label: item }));

export const getDose = (guide: Guide): GuideDose => {
  const boilStep = guide.steps.find((step: GuideStep) => step.type === StepType.boil);
  const grindStep = guide.steps.find((step: GuideStep) => step.type === StepType.grind);

  return {
    water: boilStep ? boilStep.amount : 0,
    coffee: grindStep ? grindStep.amount : 0,
    cups: 1,
  };
};
